import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './phoneBillPayController.json';

const SIMULATED_DELAY_MS = 3000;

const queryPhoneBillPaySetting = async (req, res, ctx) => {
  await new Promise((resolve) => setTimeout(resolve, SIMULATED_DELAY_MS));
  return res(ctx.json(mockResponse(apiResponses['phoneBillPayController/queryPhoneBillPaySetting'].success.default)));
};

const queryPhoneBillPayCsrCreditLimit = async (req, res, ctx) => {
  await new Promise((resolve) => setTimeout(resolve, SIMULATED_DELAY_MS));
  let key = 'default';
  try {
    const body = typeof req.json === 'function' ? await req.json() : req.body;
    if (body && (String(body.pocketId) === '2')) {
      key = 'pocketId2';
    }
  } catch (e) {}

  const mockData =
    apiResponses['phoneBillPayController/queryPhoneBillPayCsrCreditLimit'].success[key] ||
    apiResponses['phoneBillPayController/queryPhoneBillPayCsrCreditLimit'].success.default;

  return res(ctx.json(mockResponse(mockData)));
};

const initSelectAmountPage = async (req, res, ctx) => {
  await new Promise((resolve) => setTimeout(resolve, SIMULATED_DELAY_MS));
  let key = 'default';
  try {
    const body = typeof req.json === 'function' ? await req.json() : req.body;
    if (body && (String(body.pocketId) === '2')) {
      key = 'pocketId2';
    }
  } catch (e) {}

  const mockData =
    apiResponses['phoneBillPayController/initSelectAmountPage'].success[key] ||
    apiResponses['phoneBillPayController/initSelectAmountPage'].success.default;

  return res(ctx.json(mockResponse(mockData)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('phoneBillPayController/queryPhoneBillPaySetting'),
    withScenario(withAuthCheck(queryPhoneBillPaySetting))
  ),
  rest.post(
    getApiEndpoint('phoneBillPayController/queryPhoneBillPayCsrCreditLimit'),
    withScenario(withAuthCheck(queryPhoneBillPayCsrCreditLimit))
  ),
  rest.post(
    getApiEndpoint('phoneBillPayController/initSelectAmountPage'),
    withScenario(withAuthCheck(initSelectAmountPage))
  ),
];
